// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 我的作品组件样式 */
.my-works-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 40px 20px;
  min-height: 80vh;
}

/* 嵌入模式：在首页显示时的样式 */
.my-works-container.embedded {
  max-width: none;
  padding: 30px 0;
  min-height: auto;
  background: rgba(10, 10, 20, 0.6);
  border-top: 1px solid rgba(0, 240, 255, 0.2);
  border-bottom: 1px solid rgba(0, 240, 255, 0.2);
}

.my-works-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.my-works-header h2 {
  color: #00f0ff;
  font-size: 2rem;
  margin: 0;
}

.refresh-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: rgba(0, 240, 255, 0.1);
  border: 1px solid #00f0ff;
  color: #00f0ff;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s;
}

.refresh-btn:hover {
  background: rgba(0, 240, 255, 0.2);
}

.refresh-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.refresh-btn .fa-sync-alt.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* 加载状态 */
.loading-state,
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px 20px;
  color: #888;
}

.loading-state i,
.empty-state i {
  font-size: 3rem;
  margin-bottom: 20px;
  opacity: 0.5;
}

/* 作品网格 */
.works-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 24px;
}

/* 作品卡片 */
.work-card {
  background: rgba(20, 20, 30, 0.8);
  border: 1px solid rgba(0, 240, 255, 0.2);
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s;
  position: relative;
}

.work-card:hover {
  border-color: rgba(0, 240, 255, 0.5);
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 240, 255, 0.2);
}

/* 缩略图 */
.work-thumbnail {
  position: relative;
  width: 100%;
  padding-top: 100%; /* 1:1 正方形比例，最大化显示区域 */
  background: #000;
  overflow: hidden;
}

.work-thumbnail img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.work-status-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 4;
}

.status-badge {
  padding: 6px 12px;
  background: rgba(0, 240, 255, 0.2);
  border: 1px solid #00f0ff;
  color: #00f0ff;
  border-radius: 20px;
  font-size: 0.85rem;
}

.work-play-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0);
  transition: background 0.3s;
  z-index: 4; /* 确保播放按钮在最上层 */
  pointer-events: none; /* 让点击事件穿透到work-thumbnail */
}

.work-thumbnail:hover .work-play-overlay {
  background: rgba(0, 0, 0, 0.4);
}

.work-thumbnail:hover .work-play-overlay i {
  opacity: 1;
  transform: scale(1.1);
}

.work-play-overlay i {
  font-size: 3rem;
  color: #00f0ff;
  opacity: 0.8;
  transition: all 0.3s;
}

/* 进度条 - 叠加在图片上 */
.work-progress {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px 16px;
  padding-bottom: 16px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.5) 50%, transparent);
  backdrop-filter: blur(8px);
  z-index: 3;
}

.progress-bar {
  width: 100%;
  height: 6px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 6px;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #00f0ff, #00a8ff);
  border-radius: 3px;
  transition: width 0.5s ease;
}

.progress-text {
  font-size: 0.85rem;
  color: #00f0ff;
  text-align: right;
}

/* 作品信息 - 叠加在图片上 */
.work-info {
  position: absolute;
  bottom: 60px; /* 为work-actions留出空间 */
  left: 0;
  right: 0;
  padding: 16px;
  padding-bottom: 20px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.95), rgba(0, 0, 0, 0.6) 70%, transparent);
  backdrop-filter: blur(8px);
  z-index: 2;
}

.work-title {
  margin: 0 0 8px 0;
  color: #fff;
  font-size: 1.1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.work-topic {
  margin: 0 0 8px 0;
  color: #888;
  font-size: 0.9rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.work-time {
  margin: 0;
  color: #666;
  font-size: 0.8rem;
}

.work-error {
  margin: 8px 0 0 0;
  color: #ff4444;
  font-size: 0.85rem;
}

/* 操作按钮 - 叠加在图片上 */
.work-actions {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  gap: 8px;
  padding: 12px 16px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.6) 50%, transparent);
  backdrop-filter: blur(8px);
  z-index: 3;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.action-btn {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 12px;
  border: none;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  backdrop-filter: blur(4px);
  position: relative;
  z-index: 10;
}

.play-btn {
  background: rgba(0, 240, 255, 0.25);
  color: #00f0ff;
  border: 1px solid rgba(0, 240, 255, 0.4);
}

.play-btn:hover {
  background: rgba(0, 240, 255, 0.4);
  border-color: rgba(0, 240, 255, 0.6);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 240, 255, 0.3);
}

.share-btn {
  background: rgba(0, 240, 255, 0.25);
  color: #00f0ff;
  border: 1px solid rgba(0, 240, 255, 0.4);
}

.share-btn:hover {
  background: rgba(0, 240, 255, 0.4);
  border-color: rgba(0, 240, 255, 0.6);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 240, 255, 0.3);
}

.download-btn {
  background: rgba(126, 87, 255, 0.25);
  color: #c4a9ff;
  border: 1px solid rgba(126, 87, 255, 0.4);
}

.download-btn:hover {
  background: rgba(126, 87, 255, 0.4);
  border-color: rgba(126, 87, 255, 0.6);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(126, 87, 255, 0.3);
}

/* 响应式 */
@media (max-width: 768px) {
  .my-works-container {
    padding: 20px 16px;
  }

  .my-works-header h2 {
    font-size: 1.5rem;
  }

  .works-grid {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MyWorks.css"],"names":[],"mappings":"AAAA,aAAa;AACb;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kCAAkC;EAClC,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA,SAAS;AACT;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA,SAAS;AACT;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA,SAAS;AACT;EACE,iCAAiC;EACjC,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,QAAQ;AACR;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB,EAAE,sBAAsB;EACzC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,2BAA2B;EAC3B,UAAU,EAAE,eAAe;EAC3B,oBAAoB,EAAE,2BAA2B;AACnD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;EACpB,4FAA4F;EAC5F,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,YAAY,EAAE,sBAAsB;EACpC,OAAO;EACP,QAAQ;EACR,aAAa;EACb,oBAAoB;EACpB,6FAA6F;EAC7F,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,4FAA4F;EAC5F,0BAA0B;EAC1B,UAAU;EACV,8CAA8C;AAChD;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,QAAQ;AACR;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,4DAA4D;IAC5D,SAAS;EACX;AACF","sourcesContent":["/* 我的作品组件样式 */\r\n.my-works-container {\r\n  max-width: 1400px;\r\n  margin: 0 auto;\r\n  padding: 40px 20px;\r\n  min-height: 80vh;\r\n}\r\n\r\n/* 嵌入模式：在首页显示时的样式 */\r\n.my-works-container.embedded {\r\n  max-width: none;\r\n  padding: 30px 0;\r\n  min-height: auto;\r\n  background: rgba(10, 10, 20, 0.6);\r\n  border-top: 1px solid rgba(0, 240, 255, 0.2);\r\n  border-bottom: 1px solid rgba(0, 240, 255, 0.2);\r\n}\r\n\r\n.my-works-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.my-works-header h2 {\r\n  color: #00f0ff;\r\n  font-size: 2rem;\r\n  margin: 0;\r\n}\r\n\r\n.refresh-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 10px 20px;\r\n  background: rgba(0, 240, 255, 0.1);\r\n  border: 1px solid #00f0ff;\r\n  color: #00f0ff;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  transition: all 0.3s;\r\n}\r\n\r\n.refresh-btn:hover {\r\n  background: rgba(0, 240, 255, 0.2);\r\n}\r\n\r\n.refresh-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.refresh-btn .fa-sync-alt.spinning {\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  from { transform: rotate(0deg); }\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n/* 加载状态 */\r\n.loading-state,\r\n.empty-state {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 100px 20px;\r\n  color: #888;\r\n}\r\n\r\n.loading-state i,\r\n.empty-state i {\r\n  font-size: 3rem;\r\n  margin-bottom: 20px;\r\n  opacity: 0.5;\r\n}\r\n\r\n/* 作品网格 */\r\n.works-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\r\n  gap: 24px;\r\n}\r\n\r\n/* 作品卡片 */\r\n.work-card {\r\n  background: rgba(20, 20, 30, 0.8);\r\n  border: 1px solid rgba(0, 240, 255, 0.2);\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  transition: all 0.3s;\r\n  position: relative;\r\n}\r\n\r\n.work-card:hover {\r\n  border-color: rgba(0, 240, 255, 0.5);\r\n  transform: translateY(-4px);\r\n  box-shadow: 0 8px 24px rgba(0, 240, 255, 0.2);\r\n}\r\n\r\n/* 缩略图 */\r\n.work-thumbnail {\r\n  position: relative;\r\n  width: 100%;\r\n  padding-top: 100%; /* 1:1 正方形比例，最大化显示区域 */\r\n  background: #000;\r\n  overflow: hidden;\r\n}\r\n\r\n.work-thumbnail img {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: contain;\r\n}\r\n\r\n.work-status-overlay {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  z-index: 4;\r\n}\r\n\r\n.status-badge {\r\n  padding: 6px 12px;\r\n  background: rgba(0, 240, 255, 0.2);\r\n  border: 1px solid #00f0ff;\r\n  color: #00f0ff;\r\n  border-radius: 20px;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.work-play-overlay {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: rgba(0, 0, 0, 0);\r\n  transition: background 0.3s;\r\n  z-index: 4; /* 确保播放按钮在最上层 */\r\n  pointer-events: none; /* 让点击事件穿透到work-thumbnail */\r\n}\r\n\r\n.work-thumbnail:hover .work-play-overlay {\r\n  background: rgba(0, 0, 0, 0.4);\r\n}\r\n\r\n.work-thumbnail:hover .work-play-overlay i {\r\n  opacity: 1;\r\n  transform: scale(1.1);\r\n}\r\n\r\n.work-play-overlay i {\r\n  font-size: 3rem;\r\n  color: #00f0ff;\r\n  opacity: 0.8;\r\n  transition: all 0.3s;\r\n}\r\n\r\n/* 进度条 - 叠加在图片上 */\r\n.work-progress {\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  padding: 12px 16px;\r\n  padding-bottom: 16px;\r\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.5) 50%, transparent);\r\n  backdrop-filter: blur(8px);\r\n  z-index: 3;\r\n}\r\n\r\n.progress-bar {\r\n  width: 100%;\r\n  height: 6px;\r\n  background: rgba(255, 255, 255, 0.1);\r\n  border-radius: 3px;\r\n  overflow: hidden;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.progress-fill {\r\n  height: 100%;\r\n  background: linear-gradient(90deg, #00f0ff, #00a8ff);\r\n  border-radius: 3px;\r\n  transition: width 0.5s ease;\r\n}\r\n\r\n.progress-text {\r\n  font-size: 0.85rem;\r\n  color: #00f0ff;\r\n  text-align: right;\r\n}\r\n\r\n/* 作品信息 - 叠加在图片上 */\r\n.work-info {\r\n  position: absolute;\r\n  bottom: 60px; /* 为work-actions留出空间 */\r\n  left: 0;\r\n  right: 0;\r\n  padding: 16px;\r\n  padding-bottom: 20px;\r\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.95), rgba(0, 0, 0, 0.6) 70%, transparent);\r\n  backdrop-filter: blur(8px);\r\n  z-index: 2;\r\n}\r\n\r\n.work-title {\r\n  margin: 0 0 8px 0;\r\n  color: #fff;\r\n  font-size: 1.1rem;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.work-topic {\r\n  margin: 0 0 8px 0;\r\n  color: #888;\r\n  font-size: 0.9rem;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.work-time {\r\n  margin: 0;\r\n  color: #666;\r\n  font-size: 0.8rem;\r\n}\r\n\r\n.work-error {\r\n  margin: 8px 0 0 0;\r\n  color: #ff4444;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n/* 操作按钮 - 叠加在图片上 */\r\n.work-actions {\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  display: flex;\r\n  gap: 8px;\r\n  padding: 12px 16px;\r\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.6) 50%, transparent);\r\n  backdrop-filter: blur(8px);\r\n  z-index: 3;\r\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.action-btn {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  padding: 10px 12px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.3s;\r\n  backdrop-filter: blur(4px);\r\n  position: relative;\r\n  z-index: 10;\r\n}\r\n\r\n.play-btn {\r\n  background: rgba(0, 240, 255, 0.25);\r\n  color: #00f0ff;\r\n  border: 1px solid rgba(0, 240, 255, 0.4);\r\n}\r\n\r\n.play-btn:hover {\r\n  background: rgba(0, 240, 255, 0.4);\r\n  border-color: rgba(0, 240, 255, 0.6);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(0, 240, 255, 0.3);\r\n}\r\n\r\n.share-btn {\r\n  background: rgba(0, 240, 255, 0.25);\r\n  color: #00f0ff;\r\n  border: 1px solid rgba(0, 240, 255, 0.4);\r\n}\r\n\r\n.share-btn:hover {\r\n  background: rgba(0, 240, 255, 0.4);\r\n  border-color: rgba(0, 240, 255, 0.6);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(0, 240, 255, 0.3);\r\n}\r\n\r\n.download-btn {\r\n  background: rgba(126, 87, 255, 0.25);\r\n  color: #c4a9ff;\r\n  border: 1px solid rgba(126, 87, 255, 0.4);\r\n}\r\n\r\n.download-btn:hover {\r\n  background: rgba(126, 87, 255, 0.4);\r\n  border-color: rgba(126, 87, 255, 0.6);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(126, 87, 255, 0.3);\r\n}\r\n\r\n/* 响应式 */\r\n@media (max-width: 768px) {\r\n  .my-works-container {\r\n    padding: 20px 16px;\r\n  }\r\n\r\n  .my-works-header h2 {\r\n    font-size: 1.5rem;\r\n  }\r\n\r\n  .works-grid {\r\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\r\n    gap: 16px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
